import { z } from 'zod';
export const TenantStatusEnum = z.enum(['active', 'archived']);
/** Tenant META item (DynamoDB TENANT#<tid> SK=META) */
export const TenantMetaSchema = z.object({
    id: z.string().min(1).max(64),
    code: z.string().min(1).max(50), // 例：K8S-PROJECT-A
    name: z.string().min(1).max(200),
    customer_company: z.string().min(1).max(200),
    status: TenantStatusEnum,
    created_at: z.number().int(),
    created_by_user_id: z.string().uuid(),
});
export const CreateTenantSchema = z.object({
    code: z.string().trim().min(1).max(50),
    name: z.string().trim().min(1).max(200),
    // 生产工厂（原「客户公司」），可选
    customer_company: z.string().trim().max(200).optional(),
});
export const UpdateTenantSchema = z.object({
    name: z.string().trim().min(1).max(200).optional(),
    customer_company: z.string().trim().min(1).max(200).optional(),
    status: TenantStatusEnum.optional(),
});
/** User-Tenant 關聯 item (DynamoDB USER#<uid> SK=TENANT#<tid>) */
export const TenantMembershipSchema = z.object({
    user_id: z.string().uuid(),
    tenant_id: z.string().min(1).max(64),
    role: z.enum(['admin', 'editor', 'viewer']),
    status: z.enum(['active', 'disabled']),
    added_at: z.number().int(),
    added_by_user_id: z.string().uuid(),
});
export const AddMemberSchema = z.object({
    user_id: z.string().uuid(),
    role: z.enum(['admin', 'editor', 'viewer']),
});
export const UpdateMemberSchema = z.object({
    role: z.enum(['admin', 'editor', 'viewer']).optional(),
    status: z.enum(['active', 'disabled']).optional(),
});
//# sourceMappingURL=tenant.js.map